module.exports = __webpack_public_path__ + "img/tag_status.6baa0e9f.png";